import React from "react";

export function AmountCell({ value, row }) {
  const number = Number(value || 0);
  const sign = row?.Sign || row?.sign || (number > 0 ? "+" : number < 0 ? "-" : "");
  const currency = row?.Currency || row?.CurrencyCode || row?.currency || "";
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const absoluteValue = Math.abs(number);
  const className = sign === "+" ? "is-positive" : sign === "-" ? "is-negative" : "";

  return (
    <span className={`new-data-table__amount ${className}`}>
      {sign === "+" ? "+" : sign === "-" ? "-" : ""}
      {formatter.format(absoluteValue)} {currency}
    </span>
  );
}

export function StatusBadge({ value }) {
  const status = String(value || "Completed");
  const normalized = status.toLowerCase();
  const tone = normalized.includes("pending")
    ? "pending"
    : normalized.includes("process")
      ? "processing"
      : normalized.includes("time out") ||
          normalized.includes("timeout") ||
          normalized.includes("timed out")
        ? "expired"
      : normalized.includes("expir")
        ? "expired"
      : normalized.includes("reject") ||
          normalized.includes("cancel") ||
          normalized.includes("declin")
        ? "danger"
        : "completed";

  return <span className={`new-data-table__badge is-${tone}`}>{status}</span>;
}

export function DateCell({ value }) {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function StackedCell({ title, subtitle }) {
  return (
    <span className="new-data-table__stacked">
      <strong>{title || "-"}</strong>
      {subtitle ? <small>{subtitle}</small> : null}
    </span>
  );
}
